export default {
    character: {
        equipped: 1,
        belt: 2,
        socketed: 6
    },
    stored: {
        inventory: 1,
        cube: 4,
        stash: 5
    }
};



// WEBPACK FOOTER //
// ./src/lib/item-locations.js